import { Checkbox, Table, TableBody, TableHead, TableRow } from '@mui/material'
import React, { useCallback, useEffect, useMemo, useRef } from 'react'
import { HeaderItem } from './HeaderItem'
import { PageLoader } from 'components/MoonLoader'
import EmployeeApproveTableRow from './EmployeesApproveTableRow'
import { useSearchApprovedContext } from 'pages/approve/context/SearchApprovesContext'
import { HeaderCell } from './styled'
import EmployeeApproveTableStatus from './EmployeesApproveTableStatus'
import {
    approveRequest,
    delegateRequest,
    fetchApproveRequests,
    rejectRequest,
} from 'pages/approve/api/requests'
import { approveRejectRequestBody, delegateRequestBody } from 'pages/approve/api/types'
import { constructSearchBody } from 'pages/approve/context/converters'
import { Waypoint } from 'react-waypoint'

const EmployeeApproveTable = () => {
    const {
        orderBy,
        competencies,
        searchString,
        setResults,
        loading,
        offset,
        setOffset,
        total,
        newLevels,
        results,
        updateRequestsList,
    } = useSearchApprovedContext()
    const tableRef = useRef(null)
    const hasMounted = useRef(false)

    useEffect(() => {
        hasMounted.current = true

        return () => {
            hasMounted.current = false
        }
    }, [])

    const loadMore = useCallback(async () => {
        if (total && total > results.length) {
            const result = await fetchApproveRequests(
                constructSearchBody({
                    competencies,
                    searchString,
                    newLevels,
                    orderBy,
                    offset,
                })
            )

            if (!hasMounted.current) return

            if (result) {
                setResults((prev) => [...prev, ...result?.data])
                setOffset((prev) => prev + 20)
            }
        }
    }, [total, results.length, newLevels, competencies, searchString, orderBy, offset, setResults, setOffset])

    // const results: EmployeeApproveInfo[] = [{
    //     request_id: 233,
    //     name: 'Andrei Klakevich',
    //     role: 'employee',
    //     staffing_competence: 'Cloud Engineering AWS, GCP Competence',
    //     staffing_id: '1388',
    //     staffing_pic: "https://images7.bamboohr.com/151463/photos/1138-0-4.jpg?Policy=eyJTdGF0ZW1lbnQiOlt7IlJlc291cmNlIjoiaHR0cHM6Ly9pbWFnZXM3LmJhbWJvb2hyLmNvbS8xNTE0NjMvKiIsIkNvbmRpdGlvbiI6eyJEYXRlR3JlYXRlclRoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTY5Nzc1OTk5Mn0sIkRhdGVMZXNzVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzAwMzUyMDAyfX19XX0_&Signature=MXmLWl2l7pM4~98G3tKwyLCQV5RCMpkLDuN~4MskrVQl2ZharqeKgamMpu2LfxqoQQtfBySDIpIXFXjCVOQUjh3k1csZ-XoEMDH3IxUODBxH4HZxl8nq~-CfDQqMFRguRZ57NcMvaJ1NfO9Vxcue9vUbuASS7EzVJncugtjhIv6qoSVwFvBbfBTeeNhLGyDQwuSF6nIO8fWFOHsRrZdhIwX7Y64DZjYlZt164xnpm3CusJGGilsgJG~l8NFIoCetz1bADG3MA7V8lPPQS0tvdSWwM9Vo~G43WEMIXbxtUQIsRCFtYm9lcmhzTwmZB73eTOpQmoEBzuUUHoV3S1BWqw__&Key-Pair-Id=APKAIZ7QQNDH4DJY7K4Q",
    //     google_pic: '',
    //     user_id: 'CB7695C4-C224-4D3C-9E77-0D6EA87A8069',
    //     staffing_position: 'Software Engineer',
    //     new_level: 2,
    //     current_level: 1,
    //     skill_id: 'B42735CE-7445-41EF-B7BB-FE44F04C5FC5',
    //     skill_name: 'Test skill',
    //     comment: [
    //         {
    //             text: 'Mauris vulputate malesuada sit lobortis lectus tempus sollicitudin volutpat donec. Amet praesent consectetur enim hac.',
    //             author: 'Alena Dorwart',
    //             date: '12 Sep 2023',
    //             staffing_pic: "https://images7.bamboohr.com/151463/photos/1138-0-4.jpg?Policy=eyJTdGF0ZW1lbnQiOlt7IlJlc291cmNlIjoiaHR0cHM6Ly9pbWFnZXM3LmJhbWJvb2hyLmNvbS8xNTE0NjMvKiIsIkNvbmRpdGlvbiI6eyJEYXRlR3JlYXRlclRoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTY5Nzc1OTk5Mn0sIkRhdGVMZXNzVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzAwMzUyMDAyfX19XX0_&Signature=MXmLWl2l7pM4~98G3tKwyLCQV5RCMpkLDuN~4MskrVQl2ZharqeKgamMpu2LfxqoQQtfBySDIpIXFXjCVOQUjh3k1csZ-XoEMDH3IxUODBxH4HZxl8nq~-CfDQqMFRguRZ57NcMvaJ1NfO9Vxcue9vUbuASS7EzVJncugtjhIv6qoSVwFvBbfBTeeNhLGyDQwuSF6nIO8fWFOHsRrZdhIwX7Y64DZjYlZt164xnpm3CusJGGilsgJG~l8NFIoCetz1bADG3MA7V8lPPQS0tvdSWwM9Vo~G43WEMIXbxtUQIsRCFtYm9lcmhzTwmZB73eTOpQmoEBzuUUHoV3S1BWqw__&Key-Pair-Id=APKAIZ7QQNDH4DJY7K4Q"
    //         },
    //         {
    //             text: 'Arcu pharetra arcu elit morbi tortor. Consequat pretium donec eget ipsum nisi tellus pretium.',
    //             author: 'Jaylon Rhiel Madsen',
    //             date: '12 Sep 2023',
    //             staffing_pic: "https://images7.bamboohr.com/151463/photos/1138-0-4.jpg?Policy=eyJTdGF0ZW1lbnQiOlt7IlJlc291cmNlIjoiaHR0cHM6Ly9pbWFnZXM3LmJhbWJvb2hyLmNvbS8xNTE0NjMvKiIsIkNvbmRpdGlvbiI6eyJEYXRlR3JlYXRlclRoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTY5Nzc1OTk5Mn0sIkRhdGVMZXNzVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzAwMzUyMDAyfX19XX0_&Signature=MXmLWl2l7pM4~98G3tKwyLCQV5RCMpkLDuN~4MskrVQl2ZharqeKgamMpu2LfxqoQQtfBySDIpIXFXjCVOQUjh3k1csZ-XoEMDH3IxUODBxH4HZxl8nq~-CfDQqMFRguRZ57NcMvaJ1NfO9Vxcue9vUbuASS7EzVJncugtjhIv6qoSVwFvBbfBTeeNhLGyDQwuSF6nIO8fWFOHsRrZdhIwX7Y64DZjYlZt164xnpm3CusJGGilsgJG~l8NFIoCetz1bADG3MA7V8lPPQS0tvdSWwM9Vo~G43WEMIXbxtUQIsRCFtYm9lcmhzTwmZB73eTOpQmoEBzuUUHoV3S1BWqw__&Key-Pair-Id=APKAIZ7QQNDH4DJY7K4Q"
    //         },
    //     ],
    // },
    // {
    //     request_id: 234,

    //     name: 'Kirill Test',
    //     role: 'employee',
    //     staffing_competence: 'Testing',
    //     staffing_id: '1322',
    //     staffing_pic: "https://images7.bamboohr.com/151463/photos/1138-0-4.jpg?Policy=eyJTdGF0ZW1lbnQiOlt7IlJlc291cmNlIjoiaHR0cHM6Ly9pbWFnZXM3LmJhbWJvb2hyLmNvbS8xNTE0NjMvKiIsIkNvbmRpdGlvbiI6eyJEYXRlR3JlYXRlclRoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTY5Nzc1OTk5Mn0sIkRhdGVMZXNzVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzAwMzUyMDAyfX19XX0_&Signature=MXmLWl2l7pM4~98G3tKwyLCQV5RCMpkLDuN~4MskrVQl2ZharqeKgamMpu2LfxqoQQtfBySDIpIXFXjCVOQUjh3k1csZ-XoEMDH3IxUODBxH4HZxl8nq~-CfDQqMFRguRZ57NcMvaJ1NfO9Vxcue9vUbuASS7EzVJncugtjhIv6qoSVwFvBbfBTeeNhLGyDQwuSF6nIO8fWFOHsRrZdhIwX7Y64DZjYlZt164xnpm3CusJGGilsgJG~l8NFIoCetz1bADG3MA7V8lPPQS0tvdSWwM9Vo~G43WEMIXbxtUQIsRCFtYm9lcmhzTwmZB73eTOpQmoEBzuUUHoV3S1BWqw__&Key-Pair-Id=APKAIZ7QQNDH4DJY7K4Q",
    //     google_pic: '',
    //     user_id: 'CB7695C4-21313-4D3C-9E77-0D6EA87A8069',
    //     staffing_position: 'Software Engineer 2',
    //     new_level: 4,
    //     current_level: 2,
    //     skill_id: 'B42735CE-7445-41EF-B7BB-FE44F04C5FC5',
    //     skill_name: 'Test skill',
    //     comment: [
    //         {
    //             text: 'COMMENT 2 Mauris vulputate malesuada sit lobortis lectus tempus sollicitudin volutpat donec. Amet praesent consectetur enim hac.',
    //             author: 'Alena Dorwart',
    //             date: '12 Sep 2023',
    //             staffing_pic: "https://images7.bamboohr.com/151463/photos/1138-0-4.jpg?Policy=eyJTdGF0ZW1lbnQiOlt7IlJlc291cmNlIjoiaHR0cHM6Ly9pbWFnZXM3LmJhbWJvb2hyLmNvbS8xNTE0NjMvKiIsIkNvbmRpdGlvbiI6eyJEYXRlR3JlYXRlclRoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTY5Nzc1OTk5Mn0sIkRhdGVMZXNzVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzAwMzUyMDAyfX19XX0_&Signature=MXmLWl2l7pM4~98G3tKwyLCQV5RCMpkLDuN~4MskrVQl2ZharqeKgamMpu2LfxqoQQtfBySDIpIXFXjCVOQUjh3k1csZ-XoEMDH3IxUODBxH4HZxl8nq~-CfDQqMFRguRZ57NcMvaJ1NfO9Vxcue9vUbuASS7EzVJncugtjhIv6qoSVwFvBbfBTeeNhLGyDQwuSF6nIO8fWFOHsRrZdhIwX7Y64DZjYlZt164xnpm3CusJGGilsgJG~l8NFIoCetz1bADG3MA7V8lPPQS0tvdSWwM9Vo~G43WEMIXbxtUQIsRCFtYm9lcmhzTwmZB73eTOpQmoEBzuUUHoV3S1BWqw__&Key-Pair-Id=APKAIZ7QQNDH4DJY7K4Q"
    //         },
    //         {
    //             text: 'COMMENT 2 Arcu pharetra arcu elit morbi tortor. Consequat pretium donec eget ipsum nisi tellus pretium.',
    //             author: 'Jaylon Rhiel Madsen',
    //             date: '12 Sep 2023',
    //             staffing_pic: "https://images7.bamboohr.com/151463/photos/1138-0-4.jpg?Policy=eyJTdGF0ZW1lbnQiOlt7IlJlc291cmNlIjoiaHR0cHM6Ly9pbWFnZXM3LmJhbWJvb2hyLmNvbS8xNTE0NjMvKiIsIkNvbmRpdGlvbiI6eyJEYXRlR3JlYXRlclRoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTY5Nzc1OTk5Mn0sIkRhdGVMZXNzVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzAwMzUyMDAyfX19XX0_&Signature=MXmLWl2l7pM4~98G3tKwyLCQV5RCMpkLDuN~4MskrVQl2ZharqeKgamMpu2LfxqoQQtfBySDIpIXFXjCVOQUjh3k1csZ-XoEMDH3IxUODBxH4HZxl8nq~-CfDQqMFRguRZ57NcMvaJ1NfO9Vxcue9vUbuASS7EzVJncugtjhIv6qoSVwFvBbfBTeeNhLGyDQwuSF6nIO8fWFOHsRrZdhIwX7Y64DZjYlZt164xnpm3CusJGGilsgJG~l8NFIoCetz1bADG3MA7V8lPPQS0tvdSWwM9Vo~G43WEMIXbxtUQIsRCFtYm9lcmhzTwmZB73eTOpQmoEBzuUUHoV3S1BWqw__&Key-Pair-Id=APKAIZ7QQNDH4DJY7K4Q"
    //         },
    //     ],
    // },
    // {
    //     request_id: 235,

    //     name: 'Valeriy Mikle',
    //     role: 'employee',
    //     staffing_competence: 'JS',
    //     staffing_id: '1322',
    //     staffing_pic: "https://images7.bamboohr.com/151463/photos/1138-0-4.jpg?Policy=eyJTdGF0ZW1lbnQiOlt7IlJlc291cmNlIjoiaHR0cHM6Ly9pbWFnZXM3LmJhbWJvb2hyLmNvbS8xNTE0NjMvKiIsIkNvbmRpdGlvbiI6eyJEYXRlR3JlYXRlclRoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTY5Nzc1OTk5Mn0sIkRhdGVMZXNzVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzAwMzUyMDAyfX19XX0_&Signature=MXmLWl2l7pM4~98G3tKwyLCQV5RCMpkLDuN~4MskrVQl2ZharqeKgamMpu2LfxqoQQtfBySDIpIXFXjCVOQUjh3k1csZ-XoEMDH3IxUODBxH4HZxl8nq~-CfDQqMFRguRZ57NcMvaJ1NfO9Vxcue9vUbuASS7EzVJncugtjhIv6qoSVwFvBbfBTeeNhLGyDQwuSF6nIO8fWFOHsRrZdhIwX7Y64DZjYlZt164xnpm3CusJGGilsgJG~l8NFIoCetz1bADG3MA7V8lPPQS0tvdSWwM9Vo~G43WEMIXbxtUQIsRCFtYm9lcmhzTwmZB73eTOpQmoEBzuUUHoV3S1BWqw__&Key-Pair-Id=APKAIZ7QQNDH4DJY7K4Q",
    //     google_pic: '',
    //     user_id: 'CB7695C4-1231-4D3C-9E77-0D6EA87A8069',
    //     staffing_position: 'Test Engineer',
    //     new_level: 5,
    //     current_level: 1,
    //     skill_id: 'B42735CE-7445-41EF-B7BB-FE44F04C5FC5',
    //     skill_name: 'Test skill',
    //     comment: [
    //         {
    //             text: 'COMMENT 3 Mauris vulputate malesuada sit lobortis lectus tempus sollicitudin volutpat donec. Amet praesent consectetur enim hac.',
    //             author: 'Alena Dorwart',
    //             date: '12 Sep 2023',
    //             staffing_pic: "https://images7.bamboohr.com/151463/photos/1138-0-4.jpg?Policy=eyJTdGF0ZW1lbnQiOlt7IlJlc291cmNlIjoiaHR0cHM6Ly9pbWFnZXM3LmJhbWJvb2hyLmNvbS8xNTE0NjMvKiIsIkNvbmRpdGlvbiI6eyJEYXRlR3JlYXRlclRoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTY5Nzc1OTk5Mn0sIkRhdGVMZXNzVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzAwMzUyMDAyfX19XX0_&Signature=MXmLWl2l7pM4~98G3tKwyLCQV5RCMpkLDuN~4MskrVQl2ZharqeKgamMpu2LfxqoQQtfBySDIpIXFXjCVOQUjh3k1csZ-XoEMDH3IxUODBxH4HZxl8nq~-CfDQqMFRguRZ57NcMvaJ1NfO9Vxcue9vUbuASS7EzVJncugtjhIv6qoSVwFvBbfBTeeNhLGyDQwuSF6nIO8fWFOHsRrZdhIwX7Y64DZjYlZt164xnpm3CusJGGilsgJG~l8NFIoCetz1bADG3MA7V8lPPQS0tvdSWwM9Vo~G43WEMIXbxtUQIsRCFtYm9lcmhzTwmZB73eTOpQmoEBzuUUHoV3S1BWqw__&Key-Pair-Id=APKAIZ7QQNDH4DJY7K4Q"
    //         },
    //         {
    //             text: 'COMMENT 3 Arcu pharetra arcu elit morbi tortor. Consequat pretium donec eget ipsum nisi tellus pretium.',
    //             author: 'Jaylon Rhiel Madsen',
    //             date: '12 Sep 2023',
    //             staffing_pic: "https://images7.bamboohr.com/151463/photos/1138-0-4.jpg?Policy=eyJTdGF0ZW1lbnQiOlt7IlJlc291cmNlIjoiaHR0cHM6Ly9pbWFnZXM3LmJhbWJvb2hyLmNvbS8xNTE0NjMvKiIsIkNvbmRpdGlvbiI6eyJEYXRlR3JlYXRlclRoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTY5Nzc1OTk5Mn0sIkRhdGVMZXNzVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzAwMzUyMDAyfX19XX0_&Signature=MXmLWl2l7pM4~98G3tKwyLCQV5RCMpkLDuN~4MskrVQl2ZharqeKgamMpu2LfxqoQQtfBySDIpIXFXjCVOQUjh3k1csZ-XoEMDH3IxUODBxH4HZxl8nq~-CfDQqMFRguRZ57NcMvaJ1NfO9Vxcue9vUbuASS7EzVJncugtjhIv6qoSVwFvBbfBTeeNhLGyDQwuSF6nIO8fWFOHsRrZdhIwX7Y64DZjYlZt164xnpm3CusJGGilsgJG~l8NFIoCetz1bADG3MA7V8lPPQS0tvdSWwM9Vo~G43WEMIXbxtUQIsRCFtYm9lcmhzTwmZB73eTOpQmoEBzuUUHoV3S1BWqw__&Key-Pair-Id=APKAIZ7QQNDH4DJY7K4Q"
    //         },
    //     ],
    // }
    // ]

    const [selected, setSelected] = React.useState<number[]>([])

    //@ts-ignore
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = results.map((n) => n.request_id)
            setSelected(newSelecteds)
            return
        }
        setSelected([])
    }

    const handleApprove = async (comment: string) => {
        const body: approveRejectRequestBody = {
            requests: selected.map((item) => ({
                request_id: item,
                comment,
            })),
        }
        await approveRequest(body)
        setSelected([]);
        updateRequestsList();
    }
    const handleReject = async (comment: string) => {
        const body: approveRejectRequestBody = {
            requests: selected.map((item) => ({
                request_id: item,
                comment,
            })),
        }
        await rejectRequest(body)
        setSelected([]);
        updateRequestsList();
    }
    const handleDelegate = async (comment: string, userId: string) => {
        const body: delegateRequestBody = {
            requests: selected.map((item) => ({
                request_id: item,
                user_id: userId,
                comment,
            })),
        }
        await delegateRequest(body)
        setSelected([]);
        updateRequestsList();
    }

    return useMemo(() => {
        return loading ? (
            <PageLoader />
        ) : (
            <>
                <Table>
                    <TableHead>
                        <TableRow>
                            <HeaderCell padding="checkbox">
                                <Checkbox
                                    indeterminate={selected.length > 0 && selected.length < results.length}
                                    checked={results.length > 0 && selected.length === results.length}
                                    onChange={handleSelectAllClick}
                                />
                            </HeaderCell>
                            <HeaderItem name="name" title="Employee" />
                            <HeaderItem name="skill" title="Skill" />
                            <HeaderItem name="newLevel" title="New Level" />
                            <HeaderItem name="currentLevel" title="Current Level" />
                            <HeaderItem name="comment" title="Comment" />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {results.map((row,index) => (
                            <EmployeeApproveTableRow
                                row={row}
                                key={index}
                                selected={selected}
                                setSelected={setSelected}
                            />
                        ))}
                    </TableBody>
                </Table>
                <EmployeeApproveTableStatus
                    selectedLength={selected.length}
                    handleApprove={handleApprove}
                    handleDelegate={handleDelegate}
                    handleReject={handleReject}
                />
                <Waypoint scrollableAncestor={tableRef.current} onEnter={loadMore}></Waypoint>
            </>
        )
    }, [results, loading, loadMore, selected])
}

export default EmployeeApproveTable
